<template>
    <div
        class="overflow-hidden relative w-full"
        :class="[fullScreen ? 'h-full' : `h-0 ${padding}`]"
    >
        <!-- The video frame -->
        <div id="player-1" class="absolute top-0 left-0 w-full h-full border-none" />

        <!-- The overlay play button -->
        <PlayButton
            v-if="firstPlay"
            :tablet-size="tabletPlayButtonSize"
            :desktop-size="desktopPlayButtonSize"
            :aria-label="$globalLabels.play"
            @click="playVideo"
        />

        <!-- The placeholder image -->
        <img
            class="object-cover object-center absolute top-0 left-0 w-full h-full z-5"
            :class="{ hidden: !firstPlay }"
            :src="placeHolderImageSrc"
            alt=""
        >

        <!-- Optional content slot -->
        <slot v-if="firstPlay && fullScreen" />
    </div>
</template>

<script lang="ts">
import PlayButton from "./PlayButton.vue";
import YouTubePlayer from "youtube-player";

export default {
    components: { PlayButton },
    inject: ["$globalLabels"],
    props: {
        videoId: { type: String, required: true },
        placeholderImageUrl: { type: String, default: "" },
        rendition: { type: String, default: "landscape" },
        fullScreen: { type: Boolean, default: false },
        numOfComponents: { type: Number, default: 1 },
        narrow: { type: Boolean, default: false },
        isSlider: { type: Boolean, default: false },
    },
    data() {
        return {
            firstPlay: true
        };
    },
    computed: {
        placeHolderImageSrc(): string {
            if (this.placeholderImageUrl !== undefined && this.placeholderImageUrl !== "") {
                // fixed placeholder image
                return this.placeholderImageUrl;
            } else {
                // auto-generated image
                return this.videoImageUrl;
            }
        },
        padding(): string {
            return this.rendition === "landscape" ? "pt-16/9" : "pt-3/4";
        },
        tabletPlayButtonSize(): number {
            // preserve comment: md:h-24 md:w-24 md:h-16 md:w-16 md:h-10 md:w-10
            if (this.fullScreen) {
                return 24;
            } else if (this.isSlider || this.numOfComponents % 2 === 0) {
                return 16;
            } else if (this.numOfComponents % 3 === 0) {
                return 10;
            }
            return 20;
        },
        desktopPlayButtonSize(): number {
            // preserve comment: xl:h-20 xl:w-20 xl:h-16 xl:w-16 xl:h-10 xl:w-10
            if (this.fullScreen) {
                return 24;
            } else if (this.narrow) {
                if (this.isSlider || this.numOfComponents % 2 === 0) {
                    return 16;
                } else if (this.numOfComponents % 3 === 0) {
                    return 10;
                } else {
                    return 20;
                }
            } else if (this.isSlider || this.numOfComponents % 2 === 0) {
                return 20;
            } else if (this.numOfComponents % 3 === 0) {
                return 16;
            }
            return 24;
        },
        videoImageUrl() {
            if (!this.videoId) {
                return "";
            }
            return `https://img.youtube.com/vi/${this.videoId.replace(
                /&.+$/g,
                ""
            )}/0.jpg`;
        },
    },
    /***********************
     * Vue lifecycle
     ***********************/
    mounted() {
        this.videoContainerId =
            this.id === ""
                ? "video-player-" + Math.random().toString(16).slice(2)
                : this.id;
    },
    methods: {
        playVideo(): void {
            const player = YouTubePlayer("player-1", {
                videoId: this.videoId,
            });
            player.playVideo();

            this.firstPlay = false;
        },
    },
};
</script>
